import { FreeEntry } from '@brighterion/br-ui';
import { Field, FieldProps } from 'formik';
import React from 'react';
import { HandleBlur, HandleChange } from './types';

type Props = {
    dataTestId?: string;
    className?: string;
    id?: string;
    name: string;
    maxLength?: number;
    delimiter?: string;
    error?: boolean;
    errorMsg?: string;
    disabled?: boolean;
    handleChange?: HandleChange;
    handleBlur?: HandleBlur;
};

export const FormikFieldFreeEntry = ({
    dataTestId,
    className,
    name,
    id,
    error,
    errorMsg,
    maxLength = 255,
    delimiter = ';',
    ...rest
}: Props) => {
    return (
        <Field name={name}>
            {({ field, form }: FieldProps) => {
                const selectedItems = field.value.length === 0 ? [] : [...field.value.split(delimiter)];
                const interaction = (value: string[]) =>
                    form.setFieldValue(field.name, value.length === 0 ? '' : value.join(delimiter));

                return (
                    <FreeEntry
                        dataTestId={dataTestId}
                        selectedItems={selectedItems}
                        handleOptionChange={(val: string[]) => {
                            interaction(val);
                            form.setFieldTouched(field.name, true);
                        }}
                        className={className}
                        maxLength={maxLength}
                        error={error}
                        errorMsg={errorMsg}
                        {...rest}
                    />
                );
            }}
        </Field>
    );
};
